var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "field", class: _vm.classes },
    [
      _c("label", {
        attrs: { for: _vm.getName() },
        domProps: { innerHTML: _vm._s(_vm.label) },
      }),
      _vm._v(" "),
      _vm.element == "textarea"
        ? [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              attrs: {
                required: _vm.getRequired(),
                name: _vm.getName(),
                id: _vm.getName(),
                placeholder: _vm.placeholder,
              },
              domProps: { value: _vm.value },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.value = $event.target.value
                },
              },
            }),
          ]
        : _vm.element == "input"
        ? _vm.type === "checkbox"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              attrs: {
                required: _vm.getRequired(),
                name: _vm.getName(),
                id: _vm.getName(),
                placeholder: _vm.placeholder,
                type: "checkbox",
              },
              domProps: {
                checked: Array.isArray(_vm.value)
                  ? _vm._i(_vm.value, null) > -1
                  : _vm.value,
              },
              on: {
                change: function ($event) {
                  var $$a = _vm.value,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.value = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.value = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.value = $$c
                  }
                },
              },
            })
          : _vm.type === "radio"
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              attrs: {
                required: _vm.getRequired(),
                name: _vm.getName(),
                id: _vm.getName(),
                placeholder: _vm.placeholder,
                type: "radio",
              },
              domProps: { checked: _vm._q(_vm.value, null) },
              on: {
                change: function ($event) {
                  _vm.value = null
                },
              },
            })
          : _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.value,
                  expression: "value",
                },
              ],
              attrs: {
                required: _vm.getRequired(),
                name: _vm.getName(),
                id: _vm.getName(),
                placeholder: _vm.placeholder,
                type: _vm.type,
              },
              domProps: { value: _vm.value },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.value = $event.target.value
                },
              },
            })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }